import React, { Fragment, useEffect, useState } from "react";
import { Stage, Layer, Transformer, Rect } from "react-konva";
import Draggable from "react-draggable";
import TopNavbar from "../topNavbar/TopNavbar";
import {
  PIDCard,
  PIDDragAndDropTableRow,
  PIDModalTableRow,
  PIDModalTableRow2,
} from "./PIDComponents";
import { PIDCategories } from "./PIDCategories";
import { PIDData } from "./PIDData";
import jsPDF from "jspdf";
import axios from "axios";
import { HOST_URL } from "../../helpers/constants/Constants";
import { useSelector } from "react-redux";
import Select from "react-select";
import uuid from "uuid/v1";
import URLImage from "./URLImage";
import UploadedImage from "./UploadedImage";
import DrawnRect from "./DrawnRect";
import DrawnCircle from "./DrawnCircle";
import { FluidCodes } from "./PIDModalData";
import { HexColorPicker, HexColorInput } from "react-colorful";
import { ControlledMenu, MenuItem, useMenuState } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import DrawnStraightLines from "./DrawnStraightLines";
import DrawnLines from "./DrawnLines";
import DrawnArrows from "./DrawnArrows";
import EraserCursor from "./EraserCursor";
import DrawnText from "./DrawnText";
import { stages } from "konva/lib/Stage";
import { PIDStaticPropOptions } from "./PIDStaticPropOptions";
import { Canvas } from "konva/lib/Canvas";
import { Prompt } from "react-router";
import FluidCodesModal from "./FluidCodeTable";
import FluidCodesTable from "./FluidCodeTable";

var selectedProjectVar = "";
var newDrawingVar = "";
var selectedDrawingVar = {};

const PIDdragandDrop = () => {
  const dragUrl = React.useRef();
  const stageRef = React.useRef();
  const groupTrRef = React.useRef();
  const layerRef = React.useRef();
  const [images, setImages] = React.useState([]);
  const [selectedId, selectShape] = React.useState(null);
  const stage = stageRef.current?.getStage();
  const [stageSpec, setStageSpec] = useState({
    scale: 1,
    x: 0,
    y: 0,
  });
  const [texts, setTexts] = useState([]);
  const [newTexts, setNewTexts] = useState([]);
  const [staticProps, setStaticProps] = useState({
    text: "please type here",
  });
  const [selectedProject, setSelectedProject] = useState({
    text: "Select a project",
  });
  const [existingDrawings, setExistingDrawings] = useState([]);
  const [selectedDrawing, setSelectedDrawing] = useState({
    text: "Select drawing to restore",
  });
  const [tool, setTool] = useState("none");
  const [nodesArray, setNodesArray] = useState([]);
  const [lines, setLines] = useState([]);
  const [straightLines, setStraightLines] = useState([]);
  const [rects, setRects] = useState([]);
  const [arrows, setArrows] = useState([]);
  const [circles, setCircles] = useState([]);
  const [newRects, setNewRects] = useState([]);
  const [newCircles, setNewCircles] = useState([]);
  const [uploadedImage, setUploadedImage] = useState([]);
  const [fixedDirection, setFixedDirection] = useState("");
  const [filteredPIDData, setFilteredPIDData] = useState(PIDData);
  const [filteredPIDCategories, setFilteredPIDCategories] =
    useState(PIDCategories);
  const [pressedKey, setPressedKey] = useState("");
  // const [isVertical, setIsVertical] = useState(false);
  const [, updateState] = useState();
  const [history, setHistory] = useState([
    {
      circles: [],
      rects: [],
      arrows: [],
      lines: [],
      straightLines: [],
      texts: [],
      images: [],
      uploadedImage: [],
    },
  ]);
  const [historyStep, setHistoryStep] = useState(0);
  const [color, setColor] = useState("#000000");
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedPropertyName, setSelectedPropertyName] = useState("");
  const { toggleMenu, ...menuProps } = useMenuState();
  const [anchorPoint, setAnchorPoint] = useState({ x: 500, y: 500 });
  const projectList = useSelector(
    (state) => state.requestProjectsDataReducer.data
  );
  const isDrawing = React.useRef(false);
  const fileUploadEl = React.createRef();
  const colour = color;
  const Konva = window.Konva;
  let screenSize = "";
  let map = {};
  let sortedTable = PIDStaticPropOptions;

  if (window.innerWidth < 960) {
    screenSize = "small";
  } else {
    screenSize = "large";
  }

  const checkDeselect = (e) => {
    // deselect when clicked on empty area
    const clickedOnEmpty = e.target === e.target.getStage();
    if (clickedOnEmpty) {
      selectShape(null);
      groupTrRef.current.nodes([]);
      setNodesArray([]);
    }
  };

  const selectionRectRef = React.useRef();
  const selection = React.useRef({
    visible: false,
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
  });

  const updateSelectionRect = () => {
    const node = selectionRectRef.current;
    node.setAttrs({
      visible: selection.current.visible,
      x: Math.min(selection.current.x1, selection.current.x2),
      y: Math.min(selection.current.y1, selection.current.y2),
      width: Math.abs(selection.current.x1 - selection.current.x2),
      height: Math.abs(selection.current.y1 - selection.current.y2),
      fill: "rgba(0, 161, 255, 0.3)",
    });
    node.getLayer().batchDraw();
  };

  const oldPos = React.useRef(null);

  const handleMouseDown = (e) => {
    if (tool === "select") {
      const isElement = e.target.findAncestor(".elements-container");
      const isTransformer = e.target.findAncestor("Transformer");
      if (isElement || isTransformer) {
        return;
      }
      const pos = e.target.getStage().getRelativePointerPosition();
      selection.current.visible = true;
      selection.current.x1 = pos.x;
      selection.current.y1 = pos.y;
      selection.current.x2 = pos.x;
      selection.current.y2 = pos.y;
      updateSelectionRect();
    }
    if (tool === "pen" || tool === "eraser") {
      isDrawing.current = true;
      const pos = e.target.getStage().getRelativePointerPosition();
      const id = uuid();
      setLines([...lines, { tool, colour, id, points: [pos.x, pos.y] }]);
    }
    if (tool === "square") {
      isDrawing.current = true;
      const { x, y } = e.target.getStage().getRelativePointerPosition();
      const id = uuid();
      setNewRects([{ x, y, width: 0, height: 0, id, colour, tool: "rect" }]);
    }
    if (tool === "text") {
      isDrawing.current = true;
      const isElement = e.target.findAncestor(".elements-container");
      const isTransformer = e.target.findAncestor("Transformer");
      if (isElement || isTransformer) {
        return;
      }
      const pos = e.target.getStage().getRelativePointerPosition();
      selection.current.visible = true;
      selection.current.x1 = pos.x;
      selection.current.y1 = pos.y;
      selection.current.x2 = pos.x;
      selection.current.y2 = pos.y;
      updateSelectionRect();
      const { x, y } = e.target.getStage().getRelativePointerPosition();
      const id = uuid();
      setNewTexts([
        {
          x,
          y,
          width: 0,
          height: 0,
          id,
          colour,
          tool: "text",
          text: staticProps.text,
        },
      ]);
    }
    if (tool === "circle") {
      isDrawing.current = true;
      const { x, y } = e.target.getStage().getRelativePointerPosition();
      const id = uuid();
      setNewCircles([{ x, y, radius: 0, id, colour, tool: "circle" }]);
    }
    if (tool === "line" || tool === "highlight" || tool === "dotted") {
      isDrawing.current = true;
      const { x, y } = e.target.getStage().getRelativePointerPosition();
      const id = uuid();
      setStraightLines([
        ...straightLines,
        { tool, id, colour, points: [x, y] },
      ]);
    }
    if (tool === "arrow") {
      isDrawing.current = true;
      const { x, y } = e.target.getStage().getRelativePointerPosition();
      const id = uuid();
      setArrows([...arrows, { id, tool, colour, points: [x, y] }]);
    }
  };

  const handleMouseMove = (e) => {
    // no drawing - skipping
    const stage = e.target.getStage();
    const point = stage.getRelativePointerPosition();
    if (tool === "select") {
      if (!selection.current.visible) {
        return;
      }
      const pos = e.target.getStage().getRelativePointerPosition();
      selection.current.x2 = pos.x;
      selection.current.y2 = pos.y;
      updateSelectionRect();
    }
    if (!isDrawing.current) {
      return;
    }
    if (tool === "pen" || tool === "eraser") {
      let lastLine = lines[lines.length - 1];
      // add point
      lastLine.points = lastLine.points.concat([point.x, point.y]);

      // replace last
      lines.splice(lines.length - 1, 1, lastLine);
      setLines(lines.concat());
    }
    if (tool === "square") {
      const sx = newRects[0].x;
      const sy = newRects[0].y;
      const { x, y } = e.target.getStage().getRelativePointerPosition();
      const id = uuid();
      setNewRects([
        {
          x: sx,
          y: sy,
          width: x - sx,
          height: y - sy,
          id,
          colour: colour,
          tool: "rect",
        },
      ]);
    }
    if (tool === "text") {
      const sx = newTexts[0].x;
      const sy = newTexts[0].y;
      const { x, y } = e.target.getStage().getRelativePointerPosition();
      const id = uuid();
      setNewTexts([
        {
          x: sx,
          y: sy,
          width: x - sx,
          height: y - sy,
          id,
          colour: colour,
          tool: "text",
          text: staticProps.text,
        },
      ]);
      if (!selection.current.visible) {
        return;
      }
      const pos = e.target.getStage().getRelativePointerPosition();
      selection.current.x2 = pos.x;
      selection.current.y2 = pos.y;
      updateSelectionRect();
    }
    if (tool === "circle") {
      const sx = newCircles[0].x;
      const sy = newCircles[0].y;
      const { x, y } = e.target.getStage().getRelativePointerPosition();
      const id = uuid();
      const difference = (a, b) => {
        return Math.abs(a - b);
      };
      const radius = difference(x + y, sx + sy) / 2;
      setNewCircles([
        {
          x: sx,
          y: sy,
          radius,
          id,
          colour,
          tool: "circle",
        },
      ]);
    }
    if (tool === "line" || tool === "highlight" || tool === "dotted") {
      let lastLine = straightLines[straightLines.length - 1];

      if (fixedDirection === "horizontal") {
        // add point if horizontal selected
        lastLine.points = [
          lastLine.points[0],
          lastLine.points[1],
          point.x,
          lastLine.points[1],
        ];
      }
      if (fixedDirection === "vertical") {
        // add point if vertical selected
        lastLine.points = [
          lastLine.points[0],
          lastLine.points[1],
          lastLine.points[0],
          point.y,
        ];
      }
      if (fixedDirection === "") {
        // add point if no fixed direction selected
        lastLine.points = [
          lastLine.points[0],
          lastLine.points[1],
          point.x,
          point.y,
        ];
      }
      // replace last
      straightLines.splice(straightLines.length - 1, 1, lastLine);
      setStraightLines(straightLines.concat());
    }
    if (tool === "arrow") {
      let lastLine = arrows[arrows.length - 1];
      if (fixedDirection === "horizontal") {
        // add point if horizontal selected
        lastLine.points = [
          lastLine.points[0],
          lastLine.points[1],
          point.x,
          lastLine.points[1],
        ];
      }
      if (fixedDirection === "vertical") {
        // add point if vertical selected
        lastLine.points = [
          lastLine.points[0],
          lastLine.points[1],
          lastLine.points[0],
          point.y,
        ];
      }
      if (fixedDirection === "") {
        // add point if no fixed direction selected
        lastLine.points = [
          lastLine.points[0],
          lastLine.points[1],
          point.x,
          point.y,
        ];
      }
      // replace last
      arrows.splice(arrows.length - 1, 1, lastLine);
      setArrows(arrows.concat());
    }
  };

  window.addEventListener("keydown", (event) => {
    if (event.shiftKey) {
      setPressedKey(event.key);
    }
  });

  window.addEventListener("keyup", (event) => {
    setPressedKey("");
  });

  const handleMouseUp = (e) => {
    if (tool === "select") {
      oldPos.current = null;
      if (!selection.current.visible) {
        return;
      }
      const selBox = selectionRectRef.current.getClientRect();

      const elements = [];
      layerRef.current.find(".selectable").forEach((elementNode) => {
        const elBox = elementNode.getClientRect();
        if (Konva.Util.haveIntersection(selBox, elBox)) {
          elements.push(elementNode);
        }
      });

      groupTrRef.current.nodes(elements);
      selection.current.visible = false;
      // disable click event
      Konva.listenClickTap = false;
      updateSelectionRect();
    }
    isDrawing.current = false;
    if (tool === "square") {
      rects.push(...newRects);
      setRects(rects);
      mouseUpHistoryUpdate();
      setNewRects([]);
      if (pressedKey === "Shift") {
        setTool("square");
      } else {
        setTool("none");
      }
    }
    if (tool === "text") {
      oldPos.current = null;
      if (!selection.current.visible) {
        return;
      }
      selection.current.visible = false;
      updateSelectionRect();
      texts.push(...newTexts);
      setTexts(texts);
      mouseUpHistoryUpdate();
      setNewTexts([]);
      if (pressedKey === "Shift") {
        setTool("text");
      } else {
        setTool("none");
      }
    }
    if (tool === "circle") {
      circles.push(...newCircles);
      setCircles(circles);

      mouseUpHistoryUpdate();
      setNewCircles([]);
      if (pressedKey === "Shift") {
        setTool("circle");
      } else {
        setTool("none");
      }
    }
    if (
      tool === "pen" ||
      tool === "eraser" ||
      tool === "arrow" ||
      tool === "line" ||
      tool === "highlight" ||
      tool === "dotted"
    ) {
      mouseUpHistoryUpdate();
    }
    if (pressedKey === "Shift") {
      let tempTool = tool;
      setTool(tempTool);
    } else {
      setTool("none");
    }
    setFixedDirection("");
  };

  const mouseUpHistoryUpdate = () => {
    const slicedHistory = history.slice(0, historyStep + 1);
    const newHistory = slicedHistory.concat([
      {
        circles: [...circles],
        rects: [...rects],
        arrows: [...arrows],
        lines: [...lines],
        straightLines: [...straightLines],
        texts: [...texts],
        images: [...images],
        uploadedImage: [...uploadedImage],
      },
    ]);
    setHistory(newHistory);
    const newHistoryStep = historyStep + 1;
    setHistoryStep(newHistoryStep);
  };

  const handleMouseEnter = (e) => {
    if (
      tool === "square" ||
      tool === "select" ||
      tool === "text" ||
      tool === "circle" ||
      tool === "pen" ||
      tool === "line" ||
      tool === "dotted" ||
      tool === "arrow"
    ) {
      e.target.getStage().container().style.cursor = "crosshair";
    }
    if (tool === "highlight" || tool === "none") {
      e.target.getStage().container().style.cursor = "default";
    }
    if (tool === "eraser") {
      e.target.getStage().container().style.cursor = "none";
    }
  };

  const onClickTap = (e) => {
    // if we are selecting with rect, do nothing
    // if (selectionRectangle.visible()) {
    //   return;
    // }
    let stage = e.target.getStage();
    let layer = layerRef.current;
    let tr = groupTrRef.current;
    // if click on empty area - remove all selections
    if (e.target === stage) {
      selectShape(null);
      setNodesArray([]);
      tr.nodes([]);
      layer.draw();
      return;
    }

    // do nothing if clicked NOT on our rectangles
    if (!e.target.hasName("selectable")) {
      return;
    }

    // do we pressed shift or ctrl?
    const metaPressed = e.evt.shiftKey || e.evt.ctrlKey || e.evt.metaKey;
    const isSelected = tr.nodes().indexOf(e.target) >= 0;

    if (!metaPressed && !isSelected) {
      // if no key pressed and the node is not selected
      // select just one
      tr.nodes([e.target]);
      console.log(e.target.zIndex());
    } else if (metaPressed && isSelected) {
      // if we pressed keys and node was selected
      // we need to remove it from selection:
      const nodes = tr.nodes().slice(); // use slice to have new copy of array
      // remove node from array
      nodes.splice(nodes.indexOf(e.target), 1);
      tr.nodes(nodes);
    } else if (metaPressed && !isSelected) {
      // add the node into selection
      const nodes = tr.nodes().concat([e.target]);
      tr.nodes(nodes);
    }
    layer.draw();
  };

  const rectsToDraw = [...rects, ...newRects];
  const textsToDraw = [...texts, ...newTexts];
  const circlesToDraw = [...circles, ...newCircles];

  const handleWheel = (e) => {
    e.evt.preventDefault();

    const scaleBy = 1.1;
    const stage = e.target.getStage();
    const oldScale = stage.scaleX();
    const mousePointTo = {
      x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
      y: stage.getPointerPosition().y / oldScale - stage.y() / oldScale,
    };

    const newScale = e.evt.deltaY < 0 ? oldScale * scaleBy : oldScale / scaleBy;

    setStageSpec({
      scale: newScale,
      x: (stage.getPointerPosition().x / newScale - mousePointTo.x) * newScale,
      y: (stage.getPointerPosition().y / newScale - mousePointTo.y) * newScale,
    });
  };

  ///////// Download and save canvas as an image /////////
  const downloadURI = (uri, name) => {
    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onSaveImage = () => {
    let dataURL = stageRef.current?.getStage().toDataURL({ pixelRatio: 2 });
    downloadURI(dataURL, "Sketch.png");
  };

  ///////// Save Current Canvas state //////////
  const onSaveCanvasState = () => {
    if (newDrawingVar === "") {
      alert("Drawing name empty");
      return;
    }
    if (selectedProjectVar === "") {
      alert("No project selected");
      return;
    }
    if (
      existingDrawings.some(
        (e) => e.DrawingName.split(" - ")[0] === newDrawingVar
      )
    ) {
      const r = window.confirm(
        "A sketch already exists with that name, you are about to overwrite it."
      );
      if (r === false) {
        return;
      }
      const sketchIncDate = newDrawingVar + " - " + new Date().toLocaleString();

      const formData = new FormData();
      formData.append("Images", JSON.stringify(images));
      formData.append("Texts", JSON.stringify(texts));
      formData.append("Lines", JSON.stringify(lines));
      formData.append("StraightLines", JSON.stringify(straightLines));
      formData.append("Arrows", JSON.stringify(arrows));
      formData.append("Rects", JSON.stringify(rects));
      formData.append("Circles", JSON.stringify(circles));
      formData.append("UploadedImages", JSON.stringify(uploadedImage));
      formData.append("StageSpec", JSON.stringify(stageSpec));
      formData.append("Project", selectedProjectVar);
      formData.append("DrawingName", sketchIncDate);

      axios({
        method: "post",
        url: HOST_URL + "/api/savepidsketch",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          getSavedStates();
          alert("Sketch has been saved");
        })
        .catch((error) => {
          console.log(error);
        });
      return;
    }
    const sketchIncDate = newDrawingVar + " - " + new Date().toLocaleString();

    const formData = new FormData();
    formData.append("Images", JSON.stringify(images));
    formData.append("Texts", JSON.stringify(texts));
    formData.append("Lines", JSON.stringify(lines));
    formData.append("StraightLines", JSON.stringify(straightLines));
    formData.append("Arrows", JSON.stringify(arrows));
    formData.append("Rects", JSON.stringify(rects));
    formData.append("Circles", JSON.stringify(circles));
    formData.append("UploadedImages", JSON.stringify(uploadedImage));
    formData.append("StageSpec", JSON.stringify(stageSpec));
    formData.append("Project", selectedProjectVar);
    formData.append("DrawingName", sketchIncDate);

    axios({
      method: "post",
      url: HOST_URL + "/api/savepidsketch",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        getSavedStates();
        alert("Sketch has been saved");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  ///////// Restore Canvas state //////////
  const getSavedStates = () => {
    if (selectedProjectVar === "") {
      alert("No project selected");
      return;
    }

    var formData = new FormData();
    formData.append("Project", selectedProjectVar);

    axios({
      method: "post",
      url: HOST_URL + "/api/getpidsketch",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        setExistingDrawings(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  ///////// Download and save as a PDF //////////
  const onSavePDF = () => {
    var pdf = new jsPDF("l", "px", [
      stageRef.current?.getStage().width(),
      stageRef.current?.getStage().height(),
    ]);
    pdf.setTextColor("#000000");
    // first add texts
    // stage.find("Text").forEach((text) => {
    //   console.log("text =", text);
    //   console.log("text text1 =", text.text());
    //   console.log("text text2 =", text.attrs.text);
    //   const size = text.fontSize() / 0.75; // convert pixels to points
    //   pdf.setFontSize(size);
    //   pdf.text(text.text(), text.x(), text.y(), {
    //     baseline: "top",
    //     angle: -text.getAbsoluteRotation(),
    //   });
    // });

    // then put image on top of texts (so texts are not visible)
    pdf.addImage(
      stageRef.current?.getStage().toDataURL({ pixelRatio: 2 }),
      0,
      0,
      stageRef.current?.getStage().width(),
      stageRef.current?.getStage().height()
    );

    pdf.save("canvas.pdf");
  };

  const spawnText = () => {
    const scale = stageSpec.scale;
    let insertX = 0;
    let insertY = 0;
    const tempX = stageRef.current?.getStage().x();
    if (tempX > 0) {
      insertX = -Math.abs(tempX / scale);
    }
    if (tempX < 0) {
      insertX = Math.abs(tempX / scale);
    }
    const tempY = stageRef.current?.getStage().y();
    if (tempY > 0) {
      insertY = -Math.abs(tempY / scale);
    }
    if (tempY < 0) {
      insertY = Math.abs(tempY / scale);
    }

    const newTexts = texts.concat([
      {
        text: staticProps.text,
        x: insertX,
        y: insertY,
        colour,
        id: uuid(),
        tool: "text",
      },
    ]);
    setTexts(newTexts);
    const slicedHistory = history.slice(0, historyStep + 1);
    const newHistory = slicedHistory.concat([
      {
        circles: [...circles],
        rects: [...rects],
        arrows: [...arrows],
        lines: [...lines],
        straightLines: [...straightLines],
        texts: [...newTexts],
        images: [...images],
        uploadedImage: [...uploadedImage],
      },
    ]);
    setHistory(newHistory);
    const newHistoryStep = historyStep + 1;
    setHistoryStep(newHistoryStep);
  };

  const onCopy = (node) => {
    const selectedTool = node.tool;
    if (selectedTool === "pen") {
      const samePoints = [...node.points];
      const updatedPoints = samePoints.map((n) => n + 30);
      const copiedLines = lines.concat([
        {
          ...node,
          id: uuid(),
          points: [...updatedPoints],
        },
      ]);
      setLines(copiedLines);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...rects],
          arrows: [...arrows],
          lines: [...copiedLines],
          straightLines: [...straightLines],
          texts: [...texts],
          images: [...images],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (
      selectedTool === "highlight" ||
      selectedTool === "line" ||
      selectedTool === "dotted"
    ) {
      const samePoints = [...node.points];
      const updatedPoints = samePoints.map((n) => n + 30);
      const copiedStraightLines = straightLines.concat([
        {
          ...node,
          id: uuid(),
          points: [...updatedPoints],
        },
      ]);
      setStraightLines(copiedStraightLines);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...rects],
          arrows: [...arrows],
          lines: [...lines],
          straightLines: [...copiedStraightLines],
          texts: [...texts],
          images: [...images],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (selectedTool === "arrow") {
      const samePoints = [...node.points];
      const updatedPoints = samePoints.map((n) => n + 50);
      const copiedArrows = arrows.concat([
        {
          ...node,
          id: uuid(),
          points: [...updatedPoints],
        },
      ]);
      setArrows(copiedArrows);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...rects],
          arrows: [...copiedArrows],
          lines: [...lines],
          straightLines: [...straightLines],
          texts: [...texts],
          images: [...images],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (selectedTool === "rect") {
      const copiedRects = rects.concat([
        {
          ...node,
          id: uuid(),
          x: node.x + 50,
          y: node.y + 50,
        },
      ]);
      setRects(copiedRects);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...copiedRects],
          arrows: [...arrows],
          lines: [...lines],
          straightLines: [...straightLines],
          texts: [...texts],
          images: [...images],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (selectedTool === "circle") {
      const copiedCircles = circles.concat([
        {
          ...node,
          id: uuid(),
          x: node.x + 50,
          y: node.y + 50,
        },
      ]);
      setCircles(copiedCircles);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...copiedCircles],
          rects: [...rects],
          arrows: [...arrows],
          lines: [...lines],
          straightLines: [...straightLines],
          texts: [...texts],
          images: [...images],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (selectedTool === "uploadedImage") {
      const copiedUploadedImage = uploadedImage.concat([
        {
          ...node,
          id: uuid(),
          x: node.x + 50,
          y: node.y + 50,
        },
      ]);
      setUploadedImage(copiedUploadedImage);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...rects],
          arrows: [...arrows],
          lines: [...lines],
          straightLines: [...straightLines],
          texts: [...texts],
          images: [...images],
          uploadedImage: [...copiedUploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (selectedTool === "image") {
      const copiedImages = images.concat([
        {
          ...node,
          id: uuid(),
          x: node.x + 50,
          y: node.y + 50,
        },
      ]);
      setImages(copiedImages);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...rects],
          arrows: [...arrows],
          lines: [...lines],
          straightLines: [...straightLines],
          texts: [...texts],
          images: [...copiedImages],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (selectedTool === "text") {
      const copiedTexts = texts.concat([
        {
          ...node,
          id: uuid(),
          x: node.x + 50,
          y: node.y + 50,
        },
      ]);
      setTexts(copiedTexts);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...rects],
          arrows: [...arrows],
          lines: [...lines],
          straightLines: [...straightLines],
          texts: [...copiedTexts],
          images: [...images],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
  };

  ////////// add a feint grid system to the background //////////
  // const grid = 80;
  // const gridWidth = 5000;
  // const linesA = [];
  // const linesB = [];

  // for (let i = 0; i < gridWidth / grid; i++) {
  //   linesA.push(
  //     <Line
  //       strokeWidth={0.5}
  //       stroke={"black"}
  //       points={[i * grid, 0, i * grid, gridWidth]}
  //     />
  //   );

  //   linesB.push(
  //     <Line
  //       strokeWidth={0.5}
  //       stroke={"black"}
  //       points={[0, i * grid, gridWidth, i * grid]}
  //     />
  //   );
  // }

  const handleChange = (event) => {
    setStaticProps({ text: event.target.value });
  };
  const handleClick = (string) => {
    setStaticProps({ text: string });
  };

  const onColourChange = (node) => {
    const selectedTool = node.tool;
    const id = node.id;
    let newColour = color;

    if (selectedTool === "pen") {
      const index = lines
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      const updatedObj = { ...lines[index], colour: newColour };
      var updatedLines = [
        ...lines.slice(0, index),
        updatedObj,
        ...lines.slice(index + 1),
      ];
      setLines(updatedLines);
    }
    if (
      selectedTool === "highlight" ||
      selectedTool === "line" ||
      selectedTool === "dotted"
    ) {
      const index = straightLines
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      const updatedObj = { ...straightLines[index], colour: newColour };
      var updatedStraightLines = [
        ...straightLines.slice(0, index),
        updatedObj,
        ...straightLines.slice(index + 1),
      ];
      setStraightLines(updatedStraightLines);
    }
    if (selectedTool === "arrow") {
      const index = arrows
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      const updatedObj = { ...arrows[index], colour: newColour };
      var updatedArrows = [
        ...arrows.slice(0, index),
        updatedObj,
        ...arrows.slice(index + 1),
      ];
      setArrows(updatedArrows);
    }
    if (selectedTool === "rect") {
      const index = rects
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      const updatedObj = { ...rects[index], colour: newColour };
      var updatedRects = [
        ...rects.slice(0, index),
        updatedObj,
        ...rects.slice(index + 1),
      ];
      setRects(updatedRects);
    }
    if (selectedTool === "circle") {
      const index = circles
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      const updatedObj = { ...circles[index], colour: newColour };
      var updatedCircles = [
        ...circles.slice(0, index),
        updatedObj,
        ...circles.slice(index + 1),
      ];
      setCircles(updatedCircles);
    }
    if (selectedTool === "text") {
      const index = texts
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      const updatedObj = { ...texts[index], colour: newColour };
      var updatedTexts = [
        ...texts.slice(0, index),
        updatedObj,
        ...texts.slice(index + 1),
      ];
      setTexts(updatedTexts);
    }
    const slicedHistory = history.slice(0, historyStep + 1);
    const newHistory = slicedHistory.concat([
      {
        circles: updatedCircles ? [...updatedCircles] : [...circles],
        rects: updatedRects ? [...updatedRects] : [...rects],
        arrows: updatedArrows ? [...updatedArrows] : [...arrows],
        lines: updatedLines ? [...updatedLines] : [...lines],
        straightLines: updatedStraightLines
          ? [...updatedStraightLines]
          : [...straightLines],
        texts: updatedTexts ? [...updatedTexts] : [...texts],
        images: [...images],
        uploadedImage: [...uploadedImage],
      },
    ]);
    setHistory(newHistory);
    const newHistoryStep = historyStep + 1;
    setHistoryStep(newHistoryStep);
  };

  const onDelete = (node) => {
    const selectedTool = node.tool;
    const id = node.id;
    let layer = layerRef.current;
    let tr = groupTrRef.current;

    if (selectedTool === "pen") {
      const updatedLines = [...lines];
      const index = updatedLines
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      updatedLines.splice(index, 1);
      setLines(updatedLines);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...rects],
          arrows: [...arrows],
          lines: [...updatedLines],
          straightLines: [...straightLines],
          texts: [...texts],
          images: [...images],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }

    if (
      selectedTool === "highlight" ||
      selectedTool === "line" ||
      selectedTool === "dotted"
    ) {
      const updatedStraightLines = [...straightLines];
      const index = updatedStraightLines
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      updatedStraightLines.splice(index, 1);
      setStraightLines(updatedStraightLines);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...rects],
          arrows: [...arrows],
          lines: [...lines],
          straightLines: [...updatedStraightLines],
          texts: [...texts],
          images: [...images],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (selectedTool === "arrow") {
      const updatedArrows = [...arrows];
      const index = updatedArrows
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      updatedArrows.splice(index, 1);
      setArrows(updatedArrows);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...rects],
          arrows: [...updatedArrows],
          lines: [...lines],
          straightLines: [...straightLines],
          texts: [...texts],
          images: [...images],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (selectedTool === "rect") {
      const updatedRects = [...rects];
      const index = updatedRects
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      updatedRects.splice(index, 1);
      setRects(updatedRects);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...updatedRects],
          arrows: [...arrows],
          lines: [...lines],
          straightLines: [...straightLines],
          texts: [...texts],
          images: [...images],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (selectedTool === "circle") {
      const updatedCircles = [...circles];
      const index = updatedCircles
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      updatedCircles.splice(index, 1);
      setCircles(updatedCircles);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...updatedCircles],
          rects: [...rects],
          arrows: [...arrows],
          lines: [...lines],
          straightLines: [...straightLines],
          texts: [...texts],
          images: [...images],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (selectedTool === "uploadedImage") {
      const updatedUploadedImage = [...uploadedImage];
      const index = updatedUploadedImage
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      updatedUploadedImage.splice(index, 1);
      setUploadedImage(updatedUploadedImage);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...rects],
          arrows: [...arrows],
          lines: [...lines],
          straightLines: [...straightLines],
          texts: [...texts],
          images: [...images],
          uploadedImage: [...updatedUploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (selectedTool === "image") {
      const updatedImages = [...images];
      const index = updatedImages
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      updatedImages.splice(index, 1);
      setImages(updatedImages);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...rects],
          arrows: [...arrows],
          lines: [...lines],
          straightLines: [...straightLines],
          texts: [...texts],
          images: [...updatedImages],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    if (selectedTool === "text") {
      const updatedTexts = [...texts];
      const index = updatedTexts
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      updatedTexts.splice(index, 1);
      setTexts(updatedTexts);
      const slicedHistory = history.slice(0, historyStep + 1);
      const newHistory = slicedHistory.concat([
        {
          circles: [...circles],
          rects: [...rects],
          arrows: [...arrows],
          lines: [...lines],
          straightLines: [...straightLines],
          texts: [...updatedTexts],
          images: [...images],
          uploadedImage: [...uploadedImage],
        },
      ]);
      setHistory(newHistory);
      const newHistoryStep = historyStep + 1;
      setHistoryStep(newHistoryStep);
    }
    selectShape(null);
    setNodesArray([]);
    tr.nodes([]);
    layer.draw();
    return;
  };

  const updateTexts = (index, newValue) => {
    const newTexts = [...texts];
    newTexts[index].text = newValue;
  };

  const uploadImage = () => {
    fileUploadEl.current.click();
  };
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const fileChange = (ev) => {
    let file = ev.target.files[0];
    let reader = new FileReader();
    reader.addEventListener(
      "load",
      () => {
        const id = uuid();
        uploadedImage.push({
          x: 50,
          y: 50,
          id,
          width: 200,
          height: 200,
          content: reader.result,
          tool: "uploadedImage",
        });
        setUploadedImage(uploadedImage);
        fileUploadEl.current.value = null;
        forceUpdate();
        mouseUpHistoryUpdate();
      },
      false
    );
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const clearCanvas = () => {
    const r = window.confirm(
      "Are you sure you want to clear the canvas? Have you made sure you have saved it in case you need it at a later date? "
    );
    if (r === false) {
      return;
    }
    setTexts([]);
    setImages([]);
    setLines([]);
    setStraightLines([]);
    setRects([]);
    setArrows([]);
    setCircles([]);
    setUploadedImage([]);
  };

  const home = () => {
    setStageSpec({
      scale: 1,
      x: 0,
      y: 0,
    });
  };

  onkeydown = onkeyup = function (e) {
    map[e.keyCode] = e.type === "keydown";
    // console.log(e.keyCode);
    // console.log(map[16]);
    if (selectedId) {
      // Copy using Ctrl + C
      if (map[17] === true && map[67] === true) {
        onCopy(selectedId);
      }
      // Delete using Delete
      if (map[46] === true) {
        onDelete(selectedId);
      }
    }
    // Undo using Ctrl + Z
    if (map[17] === true && map[90] === true) {
      handleUndo();
    }
    // Redo using Ctrl + Y
    if (map[17] === true && map[89] === true) {
      handleRedo();
    }
    // toggle horizontal by pressing H (72)
    // toggle vertical by pressing V (86)
  };

  const uniqueClassNames = [
    ...new Map(
      PIDStaticPropOptions.map((item) => [item["ClassName"], item])
    ).values(),
  ];
  const uniquePropertyNames = [
    ...new Map(
      PIDStaticPropOptions.map((item) => [item["PropertyName"], item])
    ).values(),
  ];

  if (sortedTable === []) {
    return (
      <h2 className="text-center">
        Found no results matching selected filters
      </h2>
    );
  }

  if (selectedClassName) {
    sortedTable = sortedTable.filter((data) => {
      return data.ClassName === selectedClassName;
    });
  }

  if (selectedPropertyName) {
    sortedTable = sortedTable.filter((data) => {
      return data.PropertyName === selectedPropertyName;
    });
  }

  const handleStageDrag = (e) => {
    setStageSpec({
      ...stageSpec,
      x: e.currentTarget.x(),
      y: e.currentTarget.y(),
    });
  };

  const handleUndo = () => {
    if (historyStep === 0) {
      return;
    }
    const newHistoryStep = historyStep - 1;
    setHistoryStep(newHistoryStep);

    const previous = { ...history[newHistoryStep] };

    setCircles([...previous.circles]);
    setRects([...previous.rects]);
    setArrows([...previous.arrows]);
    setLines([...previous.lines]);
    setStraightLines([...previous.straightLines]);
    setTexts([...previous.texts]);
    setImages([...previous.images]);
    setUploadedImage([...previous.uploadedImage]);
  };

  const handleRedo = () => {
    if (historyStep === history.length - 1) {
      return;
    }
    const newHistoryStep = historyStep + 1;
    setHistoryStep(newHistoryStep);

    const next = { ...history[newHistoryStep] };

    setCircles([...next.circles]);
    setRects([...next.rects]);
    setArrows([...next.arrows]);
    setLines([...next.lines]);
    setStraightLines([...next.straightLines]);
    setTexts([...next.texts]);
    setImages([...next.images]);
    setUploadedImage([...next.uploadedImage]);
  };

  const filterPosts = (e) => {
    const value = e.target.value;
    const filteredPosts = PIDData.filter((post) =>
      post.category.toLowerCase().includes(value)
    );

    const uniqueCategories = [
      ...new Set(filteredPosts.map((category) => category.group)),
    ];
    console.log("uniqueCategories =", uniqueCategories);

    const filteredCategories = PIDCategories.filter((category) =>
      uniqueCategories.includes(category.title)
    );
    console.log("filteredPosts =", filteredPosts);
    console.log("FilteredCategories =", filteredCategories);

    setFilteredPIDData(filteredPosts);
    setFilteredPIDCategories(filteredCategories);
  };

  const removeRow = (index) => {
    const tempExistingDrawings = [...existingDrawings];

    tempExistingDrawings.splice(index, 1);
    setExistingDrawings(tempExistingDrawings);

    //add axios call to save tempExistingDrawings back to DB with deleted one removed.

    const formData = new FormData();
    formData.append("formData", JSON.stringify(tempExistingDrawings));

    axios({
      method: "post",
      url: HOST_URL + `/api/deletepidsketch`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <Prompt
        when={true}
        message="You are about to navigate away from this page, please make sure you have saved all of your work."
      />
      <TopNavbar />
      <div style={{ height: "95vh", overflowY: "auto" }}>
        <br />
        {tool === "eraser" && <EraserCursor />}
        <div
          className="row"
          style={{ width: window.innerWidth, overflowX: "hidden" }}
        >
          <div className="col-sm-4 col-lg-2" style={{ paddingLeft: 20 }}>
            <div>
              <h4 style={{ fontSize: 12, margin: 0 }}>
                <b>Step 1.</b> Select a project
              </h4>
              <div className="col justify-content-center">
                <div>
                  <Select
                    className="form-control-sm"
                    classNamePrefix={"typeahead-select"}
                    value={selectedProject}
                    onChange={(selection) => {
                      selectedProjectVar = selection.projectid;
                      setSelectedProject(selection);
                      getSavedStates();
                    }}
                    options={projectList}
                    getOptionLabel={(option) => option.text}
                    getOptionValue={(option) => option.text}
                  />
                </div>
              </div>
              <br />
              <div
                data-toggle="tooltip"
                data-placement="bottom"
                title="Please remember to save your work regularly whilst sketching
                  to avoid loss of work."
              >
                <h4 style={{ fontSize: 12, margin: 0 }}>
                  <b>Step 2.</b> Save current sketch or load a previous one.
                </h4>
              </div>
              <div className="row d-flex justify-content-center">
                <button
                  type="button"
                  className={
                    screenSize === "small"
                      ? "btn btn-xs btn-primary"
                      : "btn btn-sm btn-primary"
                  }
                  data-toggle="modal"
                  data-target="#saveLoad"
                  style={{ marginRight: "2px" }}
                >
                  Save / Load
                </button>
                <div
                  className="modal fade"
                  id="saveLoad"
                  role="dialog"
                  aria-labelledby="saveLoad"
                  data-animation="false"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          data-keyboard="true"
                          aria-label="Close"
                        ></button>
                        <h4 className="modal-title" id="saveLoad">
                          Save / Load
                        </h4>
                      </div>
                      <div className="modal-body">
                        <div className="dialog">
                          <div
                            className="dialog-body"
                            style={{ overflowY: "scroll", height: "30vh" }}
                          >
                            <div>
                              <h4 style={{ fontSize: 12, margin: 0 }}>
                                <i
                                  className="fa fa-exclamation-triangle"
                                  aria-hidden="true"
                                ></i>
                                If a sketch has been previously created, then
                                select it here
                              </h4>
                            </div>
                            <br />
                            <div className="form-group row d-flex d-flex justify-content-center">
                              <div className="col-8 p-0">
                                <Select
                                  // classNamePrefix={"typeahead-select"}
                                  maxMenuHeight={180} // not working because n typeahead class
                                  value={selectedDrawing.text}
                                  onChange={(selection) => {
                                    selectedDrawingVar = selection;
                                    setSelectedDrawing(selection);
                                  }}
                                  options={existingDrawings}
                                  getOptionLabel={(option) =>
                                    option.DrawingName
                                  }
                                  getOptionValue={(option) =>
                                    option.DrawingName
                                  }
                                  placeholder="Select sketch to load"
                                />
                              </div>
                              <button
                                className="btn btn-sm btn-primary"
                                type="submit"
                                onClick={() => {
                                  setImages(selectedDrawing.Images);
                                  setLines(selectedDrawing.Lines);
                                  setStraightLines(
                                    selectedDrawing.StraightLines
                                  );
                                  setArrows(selectedDrawing.Arrows);
                                  setRects(selectedDrawing.Rects);
                                  setCircles(selectedDrawing.Circles);
                                  setUploadedImage(
                                    selectedDrawing.UploadedImages
                                  );
                                  setTexts(selectedDrawing.Texts);
                                  setStageSpec(selectedDrawing.StageSpec);
                                  newDrawingVar =
                                    selectedDrawing.DrawingName.split(" - ")[0];
                                }}
                                style={{
                                  marginRight: "0.5rem",
                                  marginLeft: "0.5rem",
                                }}
                              >
                                Load
                              </button>
                            </div>
                            <div>
                              <h4 style={{ fontSize: 12, margin: 0 }}>
                                <i
                                  className="fa fa-exclamation-triangle"
                                  aria-hidden="true"
                                ></i>
                                If a sketch has <b>NOT </b>been previously
                                created, then enter a drawing name and save
                                below. (please ensure you save regularly to
                                avoid losing any work)
                              </h4>
                            </div>
                            <br />
                            <div className="form-group row d-flex d-flex justify-content-center">
                              <div className="col-8 p-0">
                                <input
                                  className="form-control"
                                  value={newDrawingVar}
                                  type="text"
                                  autoComplete="off"
                                  spellCheck="false"
                                  placeholder="New sketch name"
                                  defaultValue=""
                                  onChange={(elem) => {
                                    newDrawingVar = elem.target.value;
                                    setSelectedDrawing(elem.target.value);
                                  }}
                                  id="example-text-input"
                                />
                              </div>
                              <button
                                className="btn btn-sm btn-primary"
                                type="submit"
                                onClick={onSaveCanvasState}
                                style={{
                                  marginRight: "0.5rem",
                                  marginLeft: "0.5rem",
                                }}
                              >
                                Save
                              </button>
                            </div>
                            <div className="row" style={{ margin: 0 }}></div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-primary"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {console.log("existingDrawings", existingDrawings)}
                <button
                  type="button"
                  className={
                    screenSize === "small"
                      ? "btn btn-xs btn-primary"
                      : "btn btn-sm btn-primary"
                  }
                  data-toggle="modal"
                  data-target="#manageSaves"
                  style={{ marginLeft: "2px" }}
                >
                  Manage Saves
                </button>
                <div
                  className="modal fade"
                  id="manageSaves"
                  role="dialog"
                  aria-labelledby="manageSaves"
                  data-animation="false"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content" style={{ width: "600px" }}>
                      <div className="modal-header">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          data-keyboard="true"
                          aria-label="Close"
                        ></button>
                        <h4 className="modal-title" id="manageSaves">
                          Manage Saves
                        </h4>
                      </div>
                      <div className="modal-body">
                        <div className="dialog">
                          <div
                            className="dialog-body"
                            style={{ overflowY: "scroll", height: "50vh" }}
                          >
                            <div>
                              <h4 style={{ fontSize: 12, margin: 0 }}>
                                <i
                                  className="fa fa-exclamation-triangle"
                                  aria-hidden="true"
                                ></i>
                                Here you can see all of the saved sketches for
                                the selected project, where you can delete a
                                saved sketch if required.
                              </h4>
                            </div>
                            <br />

                            <div className="form-group row d-flex d-flex justify-content-center">
                              <div className="row">
                                <div className="col">
                                  <table
                                    className="table "
                                    // style={{
                                    //   overflowY: "scroll",
                                    //   // height: "100%",
                                    // }}
                                  >
                                    <thead>
                                      <tr>
                                        <th>Sketch Name</th>
                                        <th>Last save date</th>
                                        <th>Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {existingDrawings.map((sketch, i) => (
                                        <tr>
                                          <td>
                                            {sketch.DrawingName.split(" - ")[0]}
                                          </td>
                                          <td>
                                            {sketch.DrawingName.split(" - ")[1]}
                                          </td>
                                          <td
                                            style={{
                                              backgroundColor: "#FFFF",
                                              borderTopColor: "#FFFF",
                                            }}
                                            onClick={() => {
                                              const r = window.confirm(
                                                "Are you sure you want to delete this saved sketch?"
                                              );
                                              if (r === false) {
                                                return;
                                              }
                                              removeRow(i);
                                            }}
                                          >
                                            Delete
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-primary"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div
                data-toggle="tooltip"
                data-placement="bottom"
                title="Use the drag and drop tools and drawing tools. Any static properties defined in the drag and drop tools table must be populated using the text box tool."
              >
                <h4 style={{ fontSize: 12, margin: 0 }}>
                  <b>Step 3.</b> Populate the canvas.
                </h4>
              </div>
              <div
                data-toggle="tooltip"
                data-placement="bottom"
                title="You can use the publishing tools on the top right of the canvas."
              >
                <h4 style={{ fontSize: 12, margin: 0 }}>
                  <b>Step 4.</b> Publish sketch.
                </h4>
              </div>
            </div>
            <div
              className="modal fade"
              id="colourPicker"
              role="dialog"
              aria-labelledby="colourPicker"
              data-animation="false"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      data-keyboard="true"
                      aria-label="Close"
                    >
                      <span>Close</span>
                    </button>
                    <h4 className="modal-title" id="colourPicker">
                      Colour Picker
                    </h4>
                  </div>
                  <div className="modal-body">
                    <div className="dialog">
                      <div className="dialog-body">
                        <HexColorPicker color={color} onChange={setColor} />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <HexColorInput color={color} onChange={setColor} />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal modal-resize-draggable fade"
              id="fluidCodes"
              role="dialog"
              aria-labelledby="fluidCodes"
              data-animation="false"
            >
              <div className="modal-dialog" role="document">
                <Draggable handle=".modal-header">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        data-keyboard="true"
                      ></button>
                      <h4 className="modal-title" id="fluidCodes">
                        Fluid Codes Key
                      </h4>
                    </div>
                    <div className="modal-body">
                      <div className="dialog">
                        <div
                          className="dialog-body"
                          style={{ overflowY: "scroll", height: "40vh" }}
                        >
                          <FluidCodesTable />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </Draggable>
              </div>
            </div>
            <div
              className="modal modal-resize-draggable fade"
              id="staticprops"
              role="dialog"
              aria-labelledby="staticprops"
              data-animation="false"
            >
              <div className="modal-dialog" role="document">
                <Draggable handle=".modal-header">
                  <div className="modal-content" style={{ width: "500px" }}>
                    <div className="modal-header">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        data-keyboard="true"
                      ></button>
                      <h4 className="modal-title" id="staticprops">
                        Static Property Options
                      </h4>
                      <button
                        className="btn btn-primary"
                        style={{ marginRight: 20 }}
                        onClick={() => {
                          setSelectedClassName("");
                          setSelectedPropertyName("");
                        }}
                      >
                        Reset Filters
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="dialog">
                        <div
                          className="dialog-body"
                          style={{ overflowY: "scroll", height: "40vh" }}
                        >
                          <div className="form-group row">
                            <div className="col">
                              <label
                                htmlFor="ClassNameSelect"
                                className="col text-center lead"
                                style={{ margin: 0 }}
                              >
                                Item
                              </label>

                              <select
                                className="form-control form-control-sm"
                                value={selectedClassName}
                                onChange={(e) => {
                                  setSelectedClassName(e.target.value);
                                }}
                              >
                                <option value="">Select an item</option>
                                {uniqueClassNames.map((name, i) => {
                                  return (
                                    <option value={name.ClassName}>
                                      {name.ClassName}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <div className="col">
                              <label
                                htmlFor="PropertyNameSelect"
                                className="col text-center lead"
                                style={{ margin: 0 }}
                              >
                                Property Name
                              </label>
                              <select
                                className="form-control form-control-sm"
                                value={selectedPropertyName}
                                onChange={(e) => {
                                  setSelectedPropertyName(e.target.value);
                                }}
                              >
                                <option value="">Select a property</option>
                                {uniquePropertyNames.map((name, i) => {
                                  return (
                                    <option value={name.PropertyName}>
                                      {name.PropertyName}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div
                            className="row justify-content-center"
                            style={{ margin: 0, marginTop: 20 }}
                          >
                            <div>
                              <table className="table table-striped table-hover table-responsive">
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      Item
                                    </th>
                                    <th
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      Property Name
                                    </th>
                                    <th
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      Value / Guide
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {sortedTable.map((prop, i) => (
                                    <PIDModalTableRow2
                                      key={i}
                                      column1={prop.ClassName}
                                      column2={prop.PropertyName}
                                      column3={prop.Value}
                                    />
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </Draggable>
              </div>
            </div>
            <div className=" row justify-content-center">
              <input
                className="form-control form-control-sm"
                type="search"
                placeholder="Search Item Name"
                aria-label="Search"
                style={{ margin: 0 }}
                onChange={(e) => filterPosts(e)}
              />
            </div>

            <div className=" row justify-content-center">
              <p style={{ margin: 0, fontWeight: "bold" }}>
                Drag and drop tools
              </p>
            </div>
            <div
              id="accordion"
              className="accordion"
              style={{
                overflowY: "scroll",
                height:
                  screenSize === "small"
                    ? window.innerHeight * 0.3
                    : window.innerHeight * 0.5,
              }}
            >
              <div>
                {/* {console.log("filteredPIDData = ", filteredPIDData)}
                {console.log("filteredPIDCategories = ", filteredPIDCategories)} */}
                {filteredPIDCategories.map((category) => (
                  <PIDCard
                    key={"DragAndDrop" + category.title}
                    screenSize={screenSize}
                    headingId={category.heading}
                    dataTarget={category.dataTarget}
                    ariaControls={category.ariaControls}
                    title={category.title}
                  >
                    {filteredPIDData.map((item, i) => {
                      return item.group === category.title ? (
                        <PIDDragAndDropTableRow
                          key={"DragAndDrop" + item.id}
                          rowNo={item.id}
                          screenSize={screenSize}
                          title={item.category}
                          StaticProps1={item.StaticProps1}
                          StaticProps2={item.StaticProps2}
                          StaticProps3={item.StaticProps3}
                          StaticProps4={item.StaticProps4}
                          StaticProps5={item.StaticProps5}
                          StaticProps6={item.StaticProps6}
                          StaticProps7={item.StaticProps7}
                          passingTextUp={handleClick}
                        >
                          <img
                            height={screenSize === "small" ? "30rem" : "50rem"}
                            width={screenSize === "small" ? "30rem" : "50rem"}
                            objectfit="contain"
                            key={item.id}
                            alt={item.category}
                            src={item.src}
                            // draggable="true"
                            onDragStart={(e) => {
                              dragUrl.current = e.target.src;
                            }}
                          />
                        </PIDDragAndDropTableRow>
                      ) : (
                        <Fragment key={item.id}></Fragment>
                      );
                    })}
                  </PIDCard>
                ))}
              </div>
            </div>
            <div className=" row justify-content-center">
              <p style={{ margin: 0, fontWeight: "bold", marginTop: 5 }}>
                Drag and drop tools key
              </p>
            </div>
            <div className=" row justify-content-center">
              <button
                type="button"
                className={
                  screenSize === "small"
                    ? "btn btn-xs btn-primary"
                    : "btn btn-sm btn-primary"
                }
                data-backdrop="false"
                data-toggle="modal"
                data-target="#staticprops"
                style={{ width: "90%", marginBottom: "2px" }}
              >
                Static Property Options
              </button>
            </div>
            <div className=" row justify-content-center">
              <button
                type="button"
                className={
                  screenSize === "small"
                    ? "btn btn-xs btn-primary"
                    : "btn btn-sm btn-primary"
                }
                data-backdrop="false"
                data-toggle="modal"
                data-target="#fluidCodes"
                style={{ width: "90%", marginBottom: "2px" }}
              >
                Fluid Codes
              </button>
            </div>
          </div>
          <div className="col-sm-8 col-lg-10 d-flex">
            <div
              onDrop={(e) => {
                e.preventDefault();
                // register event position
                stageRef.current.setPointersPositions(e);
                // add image
                const newImages = images.concat([
                  {
                    ...stageRef.current.getRelativePointerPosition(),
                    src: dragUrl.current,
                    pidItem: dragUrl.current
                      .split("/")
                      [dragUrl.current.split("/").length - 1].slice(0, -4),
                    id: uuid(),
                    tool: "image",
                  },
                ]);
                setImages(newImages);
                const slicedHistory = history.slice(0, historyStep + 1);
                const newHistory = slicedHistory.concat([
                  {
                    circles: [...circles],
                    rects: [...rects],
                    arrows: [...arrows],
                    lines: [...lines],
                    straightLines: [...straightLines],
                    texts: [...texts],
                    images: [...newImages],
                    uploadedImage: [...uploadedImage],
                  },
                ]);
                setHistory(newHistory);
                const newHistoryStep = historyStep + 1;
                setHistoryStep(newHistoryStep);
              }}
              onDragOver={(e) => e.preventDefault()}
            >
              <div>
                <div
                  className="row"
                  style={{ paddingLeft: 12, paddingRight: 12 }}
                >
                  <div
                    style={{
                      border: "1px solid grey",
                      width: "40%",
                    }}
                  >
                    <div
                      className="row d-flex justify-content-center align-items-center"
                      style={{ paddingLeft: 12 }}
                    >
                      <div>
                        <p style={{ margin: 0, fontWeight: "bold" }}>
                          Drawing tools
                        </p>
                      </div>
                    </div>
                    <div
                      className="row d-flex justify-content-center align-items-center"
                      style={{ paddingLeft: 12, paddingRight: 22 }}
                    >
                      <div>
                        <button
                          type="button"
                          className={
                            screenSize === "small"
                              ? "btn btn-xs btn-primary "
                              : "btn btn-sm btn-primary "
                          }
                          data-toggle="modal"
                          data-target="#colourPicker"
                        >
                          Colour Picker
                        </button>
                      </div>
                      <div>
                        <div
                          style={{
                            height: screenSize === "small" ? "20px" : "30px",
                            width: screenSize === "small" ? "20px" : "30px",
                            border: "1px solid black",
                            backgroundColor: color,
                            borderRadius: "2px",
                            marginTop: "1px",
                            marginRight: "6px",
                          }}
                        />
                      </div>
                      <div>
                        <select
                          className="form-control form-control-sm"
                          value={tool}
                          onChange={(e) => {
                            setTool(e.target.value);
                          }}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Drawing Tool Select"
                        >
                          <option value="none">None</option>
                          <option value="select">Select</option>
                          <option value="text">Text</option>
                          <option value="pen">Pen</option>
                          <option value="highlight">Highlight</option>
                          <option value="line">Line</option>
                          <option value="dotted">Dotted</option>
                          <option value="arrow">Arrow</option>
                          <option value="square">Square</option>
                          <option value="circle">Circle</option>
                          <option value="eraser">Eraser</option>
                        </select>
                      </div>
                      <div className="row" style={{ marginLeft: "6px" }}>
                        <textarea
                          className={
                            screenSize === "small"
                              ? "form-control col-8"
                              : "form-control col-7"
                          }
                          // rows="8"
                          placeholder={staticProps.text}
                          onChange={handleChange}
                        ></textarea>

                        <button
                          className={
                            screenSize === "small"
                              ? "btn btn-xs btn-primary col-4"
                              : "btn btn-sm btn-primary col-5"
                          }
                          onClick={spawnText}
                        >
                          Add text
                        </button>
                      </div>
                    </div>
                    {tool === "line" ||
                    tool === "dotted" ||
                    tool === "highlight" ||
                    tool === "arrow" ? (
                      <div
                        className="row d-flex justify-content-center align-items-center"
                        style={{ paddingLeft: 12, paddingRight: 22 }}
                      >
                        <div style={{ paddingRight: 22, marginTop: 4 }}>
                          <label>Fixed Direction Tool</label>
                        </div>
                        <div>
                          <select
                            className="form-control form-control-sm"
                            value={fixedDirection}
                            onChange={(e) => {
                              setFixedDirection(e.target.value);
                            }}
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Fixed Direction Tool"
                          >
                            <option value="">None</option>
                            <option value="horizontal">Horizontal</option>
                            <option value="vertical">Vertical</option>
                          </select>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      borderTop: "1px solid grey",
                    }}
                  >
                    {/* {screenSize === "small" ? (
                      <>
                        <br />
                        <br />
                      </>
                    ) : (
                      <br />
                    )} */}
                    <div className="row d-flex justify-content-center align-items-center">
                      <p style={{ margin: 0, fontWeight: "bold" }}>Canvas</p>
                    </div>
                    <div className="row d-flex justify-content-center align-items-center">
                      <button
                        className={
                          screenSize === "small"
                            ? "btn btn-xs btn-primary"
                            : "btn btn-sm btn-primary"
                        }
                        onClick={clearCanvas}
                      >
                        Clear canvas
                      </button>
                    </div>
                    <div className="row d-flex justify-content-center align-items-center">
                      <div
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Ctrl + Z"
                      >
                        <button
                          className={
                            screenSize === "small"
                              ? "btn btn-xs btn-primary"
                              : "btn btn-sm btn-primary"
                          }
                          style={{ marginTop: 1 }}
                          onClick={handleUndo}
                        >
                          Undo
                        </button>
                      </div>

                      <button
                        className={
                          screenSize === "small"
                            ? "btn btn-xs btn-primary"
                            : "btn btn-sm btn-primary"
                        }
                        style={{ marginTop: 1, marginRight: 1, marginLeft: 1 }}
                        onClick={home}
                      >
                        Default view
                      </button>
                      <div
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Ctrl + Y"
                      >
                        <button
                          className={
                            screenSize === "small"
                              ? "btn btn-xs btn-primary"
                              : "btn btn-sm btn-primary"
                          }
                          style={{ marginTop: 1 }}
                          onClick={handleRedo}
                        >
                          Redo
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      border: "1px solid grey",
                      width: "40%",
                    }}
                  >
                    <div
                      className="row d-flex justify-content-center align-items-center"
                      style={{ paddingLeft: 12 }}
                    >
                      <div>
                        <p style={{ margin: 0, fontWeight: "bold" }}>
                          Publishing tools
                        </p>
                      </div>
                    </div>
                    <div
                      className="row d-flex justify-content-center align-items-center"
                      style={{ paddingLeft: 12 }}
                    >
                      <button
                        className={
                          screenSize === "small"
                            ? "btn btn-xs btn-primary"
                            : "btn btn-sm btn-primary"
                        }
                        type="submit"
                        onClick={onSaveImage}
                      >
                        Save sketch as Image
                      </button>
                      <button
                        className={
                          screenSize === "small"
                            ? "btn btn-xs btn-primary"
                            : "btn btn-sm btn-primary"
                        }
                        type="submit"
                        onClick={onSavePDF}
                        style={{ marginLeft: "6px", marginRight: "6px" }}
                      >
                        Save sketch as PDF
                      </button>
                      <button
                        className={
                          screenSize === "small"
                            ? "btn btn-xs btn-primary"
                            : "btn btn-sm btn-primary"
                        }
                        onClick={uploadImage}
                      >
                        Upload image
                      </button>
                      <input
                        style={{ display: "none" }}
                        type="file"
                        ref={fileUploadEl}
                        onChange={fileChange}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <ControlledMenu
                    {...menuProps}
                    anchorPoint={anchorPoint}
                    onClose={() => toggleMenu(false)}
                  >
                    <MenuItem
                      onClick={() => {
                        // onCopy(stage.pointerClickStartShape);
                        onCopy(selectedId);
                      }}
                    >
                      Copy
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        // onDelete(stage.pointerClickStartShape);
                        onDelete(selectedId);
                      }}
                    >
                      Delete
                    </MenuItem>
                    {selectedId ? (
                      selectedId.tool === "uploadedImage" ||
                      selectedId.tool === "image" ? (
                        <></>
                      ) : (
                        <MenuItem
                          onClick={() => {
                            // console.log("selectedId =", selectedId);
                            onColourChange(selectedId);
                          }}
                        >
                          Update Colour
                        </MenuItem>
                      )
                    ) : null}
                    <MenuItem
                      onClick={() => {
                        stage.pointerClickStartShape.moveUp();
                      }}
                    >
                      Move Up
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        stage.pointerClickStartShape.moveDown();
                      }}
                    >
                      Move Down
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        stage.pointerClickStartShape.moveToTop();
                      }}
                    >
                      To Top
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        stage.pointerClickStartShape.moveToBottom();
                      }}
                    >
                      To Bottom
                    </MenuItem>
                  </ControlledMenu>
                  <Stage
                    width={
                      screenSize === "small"
                        ? window.innerWidth * 0.64
                        : window.innerWidth * 0.82
                    }
                    height={
                      screenSize === "small"
                        ? window.innerHeight * 0.7
                        : window.innerHeight * 0.8
                    }
                    onMouseDown={(checkDeselect, handleMouseDown)}
                    onMousemove={handleMouseMove}
                    onMouseup={handleMouseUp}
                    onMouseEnter={handleMouseEnter}
                    onTouchStart={checkDeselect}
                    onClick={(checkDeselect, onClickTap)}
                    style={{
                      borderLeft: "1px solid grey",
                      borderRight: "1px solid grey",
                      borderBottom: "1px solid grey",
                      height:
                        screenSize === "small"
                          ? window.innerHeight * 0.7
                          : window.innerHeight * 0.8,
                    }}
                    ref={stageRef}
                    draggable={tool !== "none" ? false : true}
                    scaleX={stageSpec.scale}
                    scaleY={stageSpec.scale}
                    x={stageSpec.x}
                    y={stageSpec.y}
                    onWheel={handleWheel}
                    onDragEnd={handleStageDrag}
                    onContextMenu={(e) => {
                      e.evt.preventDefault();
                      if (e.target === e.target.getStage()) {
                        return;
                      }
                      toggleMenu(true);
                      var containerRect = stage
                        .container()
                        .getBoundingClientRect();
                      setAnchorPoint({
                        x: containerRect.left + stage.getPointerPosition().x,
                        y: containerRect.top + stage.getPointerPosition().y,
                      });
                    }}
                  >
                    <Layer ref={layerRef}>
                      {circlesToDraw.map((circle, i) => {
                        return (
                          <DrawnCircle
                            key={i}
                            color={circle.colour}
                            shapeProps={circle}
                            stageScale={stageSpec.scale}
                            radius={circle.radius}
                            isSelected={circle === selectedId}
                            onSelect={(e) => {
                              if (e.current !== undefined) {
                                let temp = nodesArray;
                                if (!nodesArray.includes(e.current))
                                  temp.push(e.current);
                                setNodesArray(temp);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.getLayer().batchDraw();
                              }
                              selectShape(circle);
                              // const nodeIndex = nodesArray.zIndex();
                              // console.log(nodeIndex);
                              console.log(e);
                            }}
                            onChange={(newAttrs) => {
                              const updatedCircles = circles.slice();
                              updatedCircles[i] = newAttrs;
                              setCircles(updatedCircles);

                              const slicedHistory = history.slice(
                                0,
                                historyStep + 1
                              );
                              const newHistory = slicedHistory.concat({
                                circles: [...updatedCircles],
                                rects: [...rects],
                                arrows: [...arrows],
                                lines: [...lines],
                                straightLines: [...straightLines],
                                texts: [...texts],
                                images: [...images],
                                uploadedImage: [...uploadedImage],
                              });
                              setHistory(newHistory);
                              const newHistoryStep = historyStep + 1;
                              setHistoryStep(newHistoryStep);
                            }}
                            tool={tool}
                          />
                        );
                      })}

                      {rectsToDraw.map((rect, i) => {
                        return (
                          <DrawnRect
                            key={i}
                            shapeProps={rect}
                            color={rect.colour}
                            isSelected={rect === selectedId}
                            onSelect={(e) => {
                              if (e.current !== undefined) {
                                let temp = nodesArray;
                                if (!nodesArray.includes(e.current))
                                  temp.push(e.current);
                                setNodesArray(temp);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.getLayer().batchDraw();
                              }
                              selectShape(rect);
                            }}
                            onChange={(newAttrs) => {
                              const updatedRects = rects.slice();
                              updatedRects[i] = newAttrs;
                              setRects(updatedRects);
                              const slicedHistory = history.slice(
                                0,
                                historyStep + 1
                              );
                              const newHistory = slicedHistory.concat({
                                circles: [...circles],
                                rects: [...updatedRects],
                                arrows: [...arrows],
                                lines: [...lines],
                                straightLines: [...straightLines],
                                texts: [...texts],
                                images: [...images],
                                uploadedImage: [...uploadedImage],
                              });
                              setHistory(newHistory);
                              const newHistoryStep = historyStep + 1;
                              setHistoryStep(newHistoryStep);
                            }}
                            tool={tool}
                          />
                        );
                      })}
                      {arrows.map((arrow, i) => {
                        return (
                          <DrawnArrows
                            key={i}
                            shapeProps={arrow}
                            stageScale={stageSpec.scale}
                            isSelected={arrow === selectedId}
                            onSelect={(e) => {
                              if (e.current !== undefined) {
                                let temp = nodesArray;
                                if (!nodesArray.includes(e.current))
                                  temp.push(e.current);
                                setNodesArray(temp);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.getLayer().batchDraw();
                              }
                              selectShape(arrow);
                            }}
                            onChange={(newAttrs) => {
                              const updatedArrows = arrows.slice();
                              updatedArrows[i] = newAttrs;
                              setArrows(updatedArrows);
                              const slicedHistory = history.slice(
                                0,
                                historyStep + 1
                              );
                              const newHistory = slicedHistory.concat({
                                circles: [...circles],
                                rects: [...rects],
                                arrows: [...updatedArrows],
                                lines: [...lines],
                                straightLines: [...straightLines],
                                texts: [...texts],
                                images: [...images],
                                uploadedImage: [...uploadedImage],
                              });
                              setHistory(newHistory);
                              const newHistoryStep = historyStep + 1;
                              setHistoryStep(newHistoryStep);
                            }}
                            tool={tool}
                          />
                        );
                      })}
                      {lines.map((line, i) => {
                        return (
                          <DrawnLines
                            key={i}
                            shapeProps={line}
                            isSelected={line === selectedId}
                            onSelect={(e) => {
                              if (e.current !== undefined) {
                                let temp = nodesArray;
                                if (!nodesArray.includes(e.current))
                                  temp.push(e.current);
                                setNodesArray(temp);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.getLayer().batchDraw();
                              }
                              selectShape(line);
                            }}
                            onChange={(newAttrs) => {
                              const updatedLines = lines.slice();
                              updatedLines[i] = newAttrs;
                              setLines(updatedLines);
                              const slicedHistory = history.slice(
                                0,
                                historyStep + 1
                              );
                              const newHistory = slicedHistory.concat({
                                circles: [...circles],
                                rects: [...rects],
                                arrows: [...arrows],
                                lines: [...updatedLines],
                                straightLines: [...straightLines],
                                texts: [...texts],
                                images: [...images],
                                uploadedImage: [...uploadedImage],
                              });
                              setHistory(newHistory);
                              const newHistoryStep = historyStep + 1;
                              setHistoryStep(newHistoryStep);
                            }}
                            tool={tool}
                          />
                        );
                      })}
                      {straightLines.map((line, i) => {
                        return (
                          <DrawnStraightLines
                            key={i}
                            shapeProps={line}
                            isSelected={line === selectedId}
                            onSelect={(e) => {
                              if (e.current !== undefined) {
                                let temp = nodesArray;
                                if (!nodesArray.includes(e.current))
                                  temp.push(e.current);
                                setNodesArray(temp);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.getLayer().batchDraw();
                              }
                              selectShape(line);
                            }}
                            onChange={(newAttrs) => {
                              const updatedStraightLines =
                                straightLines.slice();
                              updatedStraightLines[i] = newAttrs;
                              setStraightLines(updatedStraightLines);
                              const slicedHistory = history.slice(
                                0,
                                historyStep + 1
                              );
                              const newHistory = slicedHistory.concat({
                                circles: [...circles],
                                rects: [...rects],
                                arrows: [...arrows],
                                lines: [...lines],
                                straightLines: [...updatedStraightLines],
                                texts: [...texts],
                                images: [...images],
                                uploadedImage: [...uploadedImage],
                              });
                              setHistory(newHistory);
                              const newHistoryStep = historyStep + 1;
                              setHistoryStep(newHistoryStep);
                            }}
                            tool={tool}
                          />
                        );
                      })}
                      {images.map((image, index) => {
                        return (
                          <URLImage
                            image={image}
                            key={index}
                            shapeProps={image}
                            isSelected={image === selectedId}
                            onSelect={(e) => {
                              if (e.current !== undefined) {
                                let temp = nodesArray;
                                if (!nodesArray.includes(e.current))
                                  temp.push(e.current);
                                setNodesArray(temp);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.getLayer().batchDraw();
                              }
                              selectShape(image);
                            }}
                            onChange={(newAttrs) => {
                              const updatedImages = images.slice();
                              updatedImages[index] = newAttrs;
                              setImages(updatedImages);
                              const slicedHistory = history.slice(
                                0,
                                historyStep + 1
                              );
                              const newHistory = slicedHistory.concat({
                                circles: [...circles],
                                rects: [...rects],
                                arrows: [...arrows],
                                lines: [...lines],
                                straightLines: [...straightLines],
                                texts: [...texts],
                                images: [...updatedImages],
                                uploadedImage: [...uploadedImage],
                              });
                              setHistory(newHistory);
                              const newHistoryStep = historyStep + 1;
                              setHistoryStep(newHistoryStep);
                            }}
                            tool={tool}
                          />
                        );
                      })}
                      {uploadedImage.map((image, i) => {
                        return (
                          <UploadedImage
                            imageUrl={image.content}
                            image={image}
                            key={i}
                            shapeProps={image}
                            isSelected={image === selectedId}
                            onSelect={(e) => {
                              if (e.current !== undefined) {
                                let temp = nodesArray;
                                if (!nodesArray.includes(e.current))
                                  temp.push(e.current);
                                setNodesArray(temp);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.getLayer().batchDraw();
                              }
                              selectShape(image);
                            }}
                            onChange={(newAttrs) => {
                              const updatedUploadedImage =
                                uploadedImage.slice();
                              updatedUploadedImage[i] = newAttrs;
                              setUploadedImage(updatedUploadedImage);
                              const slicedHistory = history.slice(
                                0,
                                historyStep + 1
                              );
                              const newHistory = slicedHistory.concat({
                                circles: [...circles],
                                rects: [...rects],
                                arrows: [...arrows],
                                lines: [...lines],
                                straightLines: [...straightLines],
                                texts: [...texts],
                                images: [...images],
                                uploadedImage: [...updatedUploadedImage],
                              });
                              setHistory(newHistory);
                              const newHistoryStep = historyStep + 1;
                              setHistoryStep(newHistoryStep);
                            }}
                            tool={tool}
                          />
                        );
                      })}
                      {textsToDraw.map((text, index) => {
                        return (
                          <DrawnText
                            key={index}
                            stage={stage}
                            textProps={text}
                            color={text.colour}
                            text={text.text}
                            updateTexts={updateTexts}
                            stageScale={stageSpec.scale}
                            isSelected={text === selectedId}
                            onSelect={(e) => {
                              if (e.current !== undefined) {
                                let temp = nodesArray;
                                if (!nodesArray.includes(e.current))
                                  temp.push(e.current);
                                setNodesArray(temp);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.nodes(nodesArray);
                                groupTrRef.current.getLayer().batchDraw();
                              }
                              selectShape(text);
                            }}
                            onChange={(newAttrs) => {
                              const updatedTexts = texts.slice();
                              updatedTexts[index] = newAttrs;
                              setTexts(updatedTexts);
                              const slicedHistory = history.slice(
                                0,
                                historyStep + 1
                              );
                              const newHistory = slicedHistory.concat({
                                circles: [...circles],
                                rects: [...rects],
                                arrows: [...arrows],
                                lines: [...lines],
                                straightLines: [...straightLines],
                                texts: [...updatedTexts],
                                images: [...images],
                                uploadedImage: [...uploadedImage],
                              });
                              setHistory(newHistory);
                              const newHistoryStep = historyStep + 1;
                              setHistoryStep(newHistoryStep);
                            }}
                            tool={tool}
                            textIndex={index}
                          />
                        );
                      })}
                      <Transformer
                        ref={groupTrRef}
                        rotationSnaps={[0, 45, 90, 135, 180, 225, 270, 315]}
                        // shouldOverdrawWholeArea={true}
                        boundBoxFunc={(oldBox, newBox) => {
                          // limit resize
                          if (newBox.width < 5 || newBox.height < 5) {
                            return oldBox;
                          }
                          return newBox;
                        }}
                      />
                      <Rect fill="rgba(0,0,255,0.5)" ref={selectionRectRef} />
                    </Layer>
                  </Stage>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PIDdragandDrop;
